import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Stack,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { ProcessPresentationProps, ProcessStepItem } from '../types';
import ProcessStepPresentation from './ProcessStepPresentation';
import { SectionAnchor } from '../../../shared/components';

const ProcessPresentation: React.FC<ProcessPresentationProps> = ({
  id,
  heading,
  description,
  steps
}) => {
  return (
    <>
      <SectionAnchor id={id} />
      <Box 
        as="section"
        pt={{ base: 4, md: 6 }} pb={{ base: 8, md: 12 }}
        bg={useColorModeValue('gray.50', 'gray.800')}
      >
      <Container maxW="container.xl">
        <Stack spacing={8} align="center" mb={16}>
          <Heading 
            as="h2" 
            size="xl"
            bgGradient="linear(to-r, brand.primary.dark, brand.primary.base)"
            bgClip="text"
            textAlign="center"
          >
            {heading}
          </Heading>
          <Text fontSize="lg" color="gray.600" maxW="800px" textAlign="center">
            {description}
          </Text>
        </Stack>

        <VStack spacing={6} align="stretch">
          {steps.map((step: ProcessStepItem, index: number) => (
            <ProcessStepPresentation
              key={index}
              title={step.title}
              description={step.description}
              icon={step.icon}
              stepNumber={index + 1}
              isLastStep={index === steps.length - 1}
            />
          ))}
        </VStack>
      </Container>
    </Box>
    </>
  );
};

export default ProcessPresentation;